export const baseURL = "https://api.doctrue.in/api/v1";
// export const baseURL = "http://localhost:8000/api/v1";
// export const baseURL = "https://test.doctrue.in/api/v1";


// fedevtv branch → point at dev API (do not merge this line to main)
// export const baseURL = "https://dev.api.doctrue.in/api/v1";


export const baseURLForQrLogin = "https://tv.doctrue.in";
// export const baseURLForQrLogin = "https://dt-tv-git-redesign-the-ui-doctrues-projects.vercel.app";

export const DT_DEFAULT_UUID = "30368881-79e2-4ff3-9d7d-c376ea1e8f7e";

export const trialClinics = [
  "78f9f866-12f7-42a1-b440-086b4be00ada",
  "e7f4c69c-fea8-4c31-a2f4-15ff483791d1",
  "fe2c0239-7ef2-4e0c-a65c-545c418d068f",
  "17fbcc7f-37e7-493a-8ff8-f88d3c06fccb",
  "02775e36-547b-4e39-aa14-fd75aea718b8",
];

export const bimbaModelClinics = ["c2823789-282e-458a-8b26-e1002a48c543"];

export const adminAccess = [
  "830b6f09-c99f-40ed-85d2-84e2ae183578",
  "8054dc6e-a8bf-44a1-909e-188bf58ef675",
];

export const estimateVisitTime = ["fa577fb4-6353-44ae-9a41-0d362d0ab5ce"];

export const scanQueueClinincs = [
  // "7e32dbc9-4404-4688-b01b-eaa06ef456eb",
  "ea071a5b-e6c2-4bd1-9ed2-ce44e4505090",
];

export const petHospitalQueueImageClinics = [
  "7c8eb809-8062-42fe-b235-f5e759125bd5",
];

export const showSlotTimingClinics = [
  "7e32dbc9-4404-4688-b01b-eaa06ef456eb",
  "7c8eb809-8062-42fe-b235-f5e759125bd5",
];

export const patientNameMasking = ["17af49f6-1610-4d57-974b-622ada40406d"];

// export const sortBySlotTimeClinics = [
//   "7c8eb809-8062-42fe-b235-f5e759125bd5",
//   // "7e32dbc9-4404-4688-b01b-eaa06ef456eb",
// ];
